import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Shared catalog card chrome for Clipping Studio (Graphics elements, Text templates).
 * Preview content is projected via ng-content.
 *
 * Body click emits cardClick. Overlay Edit/Delete buttons emit their own events
 * and stop propagation so they do not also fire cardClick.
 */
@Component({
  selector: "evrideo-clipping-studio-catalog-card",
  templateUrl: "./clipping-studio-catalog-card.component.html",
  styleUrls: ["./clipping-studio-catalog-card.component.scss"],
})
export class ClippingStudioCatalogCardComponent {
  @Input() title = "";
  @Input() isEditMode = true;
  /** Optional bottom-left duration badge (e.g. graphics catalog). */
  @Input() durationLabel: string | null = null;
  @Input() overlayLabel = "Edit";
  /** When true, shows a Delete action next to Edit on hover overlay. */
  @Input() showDeleteAction = false;
  @Input() deleteOverlayLabel = "Delete";
  @Output() cardClick = new EventEmitter<void>();
  @Output() editClick = new EventEmitter<void>();
  @Output() deleteClick = new EventEmitter<void>();

  onCardClick(): void {
    if (!this.isEditMode) return;
    this.cardClick.emit();
  }

  onEditClick(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.isEditMode) return;
    this.editClick.emit();
  }

  onDeleteClick(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.isEditMode) return;
    this.deleteClick.emit();
  }
}
